import type {
  Nullable,
  RvExpandedDetails,
} from '~/types'

type RVCategory = 'Motorized' | 'RV Cottage' | 'Towable'

/**
 * Returns the RV category for a given RV type.
 *
 * @param RVType The RV type to get the category for.
 * @returns The RV category.
 */
export function getRvCategory(RVType?: RvExpandedDetails['RVType']): Nullable<RVCategory> {
  if (!RVType) {
    return null
  }

  const map: Record<NonNullable<RvExpandedDetails['RVType']>, RVCategory> = {
    FifthWheel: 'Towable',
    TentTrailer: 'Towable',
    TravelTrailer: 'Towable',
    VintageTrailer: 'Towable',
    ToyHauler: 'Towable',
    Hybrid: 'Towable',
    Trailer: 'Towable',
    MicroTrailer: 'Towable',

    ClassA: 'Motorized',
    ClassB: 'Motorized',
    ClassC: 'Motorized',
    VintageMotorHome: 'Motorized',
    MotorHome: 'Motorized',
    Campervan: 'Motorized',
    TruckCamper: 'Motorized',

    RVCottage: 'RV Cottage',
  }

  return map[RVType]
}

/**
 * Returns wether or not the RV has the given amenity.
 *
 * @param amenities The amenities to check.
 * @param amenity The amenity to check for.
 * @returns True if the RV has the given amenity, false otherwise.
 */
export function getRvAmenity(amenities: string[], amenity?: string): boolean {
  if (!amenity || !amenities.length) {
    return false
  }

  return Boolean(amenities.find((item) => String(item).toLowerCase() === String(amenity).toLowerCase()))
}
